import { GodziDropResultType, GodziDropService, IGodziDropOption, useChipSetStore, usePlayerStore } from '@slot-nx/core'
import { registerNormalSpaceBarEvent } from '../spin/SpinUtil'
import { assetManager } from '../assetManager'
import { useGameStore, GameStatus } from '../game/store/GameStore'
import { useGodziDropStore } from './store/godziDropStore'
import { useVideoRecordingStore } from '@slot-nx/video-recorder'
import { threecomboolympusMachine } from '../machine/threecomboolympusMachine'

const godziDropSvcOptions: IGodziDropOption = {

  store: useGodziDropStore,
  loadGodziResource: async () => {
    await assetManager.loadGodziDropSource()
  },
  prepareGodziSpinData: () => {
    const currentSpinNum = useGodziDropStore.getState().freeSpinCount
    useGodziDropStore.setState({ freeSpinCount: currentSpinNum - 1 })
    const currentGameResult = useGodziDropStore.getState().gameResultList.shift()
    useGameStore.setState({ gameResult: currentGameResult })
    const chipIndex = useChipSetStore.getState().chipSet.findIndex(chip => chip === currentGameResult?.mgResult.playStake)
    useChipSetStore.setState({ currentIndex: chipIndex })
    useGameStore.setState({ isReadyToStop: true })
  },
  onStartRatioPrizeCallback: () => {
    threecomboolympusMachine.send({ type: 'exit godzi drop for ratio prize' })
  },
  onStartFreeGameCallback: () => {
    registerNormalSpaceBarEvent()
    threecomboolympusMachine.send({ type: 'start godzi spin flow' })
  },
  onStartFreeSpinCallback: () => {
    registerNormalSpaceBarEvent()
    threecomboolympusMachine.send({ type: 'start godzi spin flow' })
  },
  onCloseTotalWinCallback: () => {
    // RatioPrize 是獨立的倍數獎金，不會經過 spinning，所以要在這裡補記 session 派彩。
    // FreeGame / FreeSpin 的派彩來自 gameResultList 重播的每一轉，已由 onSpinning 記過，
    // 這裡再記一次會重複計算。
    const { type, payout } = useGodziDropStore.getState()
    if (type === GodziDropResultType.RatioPrize && payout > 0) {
      usePlayerStore.getState().updateSessionWinLose(0, payout)
    }
    useGameStore.setState({ gameStatus: GameStatus.Normal })
    useVideoRecordingStore.setState({ isSharing: false })
    registerNormalSpaceBarEvent()
    threecomboolympusMachine.send({ type: 'show godziwin finished' })
  },
}

export const godziDropService = new GodziDropService(godziDropSvcOptions)
